import './App.css';
import Home from "./pagine/Home.js";
import Gallery from "./pagine/Gallery.js";
import About from "./pagine/About.js";
import Navbar from "./componenti/Navbar.js";
import Side from "./componenti/Side.js";
import Slideshow from "./componenti/Slideshow.js";
import { Routes, Route } from 'react-router';

function App() {
  return (
    <div className='orientamento'>
      <div className='contieniPagina'>
        <section className='pagina'>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/gallery/:index" element={<Slideshow />} />
            <Route path="/about" element={<About destinazione="" />} />
            <Route path="/about/showroom" element={<About destinazione="showroom" />} />
            <Route path="/about/contatti" element={<About destinazione="contatti" />} />
          </Routes>
        </section>
      </div>
      <div className='side'>
        <Side />
      </div>
    </div>
  );
}

export default App;
